import { observer } from 'mobx-react-lite'
import { Status, Typography } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { useRcsContext } from 'pages/settings/pages/rcs/context/rcsContext'
import { GuideRcsButton } from '../../RcsAction'

import styles from './styles.module.scss'

export const RcsInfoHeader = observer(() => {
  const { rcs, statusIntentMap, statusIconMap, statusTitleMap } = useRcsContext()

  if (!rcs) return null

  return (
    <section className={styles.container}>
      <div className={styles.left}>
        <Typography ariaLabel={getAriaLabel('rcsHeaderName')} variant={'heading-lg'}>
          {rcs.name}
        </Typography>
        <Status
          title={statusTitleMap[rcs.status]}
          intent={statusIntentMap[rcs.status]}
          icon={statusIconMap[rcs.status]}
          emphasis={'high'}
        />
      </div>
      <div className={styles.right}>
        <GuideRcsButton className={styles.guideButton} />
      </div>
    </section>
  )
})
